<template>
    <message-bubble
        :is-mine="isMine"
        :message="message"
    >
        <template v-for="(item, index) in contentList">
            <span
                v-if="item.name === 'text'"
                :key="index"
                class="text-box"
            >{{ item.text }}</span>
            <img
                v-else-if="item.name === 'img'"
                :key="index"
                :src="item.src"
                width="20px"
                height="20px"
            >
        </template>
    </message-bubble>
</template>

<script>
import MessageBubble from '../MessageBubble.vue'
import { decodeText } from '@/utils/funcTim.js'

export default {
    name: 'TextElement',
    components: {
        MessageBubble
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        isMine: {
            type: Boolean
        }
    },
    computed: {
        contentList() {
            return decodeText(this.payload)
        }
    }
}
</script>

<style lang="scss" scoped>
.text-box{
    display: inline-block;
    width: 100%;
    overflow: hidden;
}
</style>
